import Button from '@/componentv2/button/button';
import Image from 'next/image';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import { PortableTextBlock } from '@portabletext/react';
import { urlForImage } from '@/sanity/lib/utils';
import { imageData } from '@/config/defaultBlur';
import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import Typography from '@/componentv2/typography/typography';

/* eslint-disable @typescript-eslint/no-explicit-any */

interface FeatureContentBlockProps {
  contentBlock: any;
  className?: string;
  hideImage?: boolean;
}

export default function FeatureContentBlock({
  contentBlock,
  className,
  hideImage,
}: FeatureContentBlockProps) {
  return (
    <div className={`product-feature-item ${className}`}>
      <div
        className={`feature-content ${contentBlock?.image ? 'has-image' : ''}`}
      >
        {contentBlock?.icon?.name && (
          <div className="feature-icon">
            <FontAwesomeIcon
              style={contentBlock?.icon?.style}
              name={contentBlock?.icon?.name}
            />
          </div>
        )}
        {contentBlock?.title && (
          <Typography style="h4" className="text-black">
            {contentBlock?.title}
          </Typography>
        )}
        {contentBlock?.description && (
          <div className="features-description">
            <LandingPortableText
              value={contentBlock?.description as PortableTextBlock[]}
            />
          </div>
        )}
        {contentBlock?.button?.text && (
          <div className="button-outer d-none d-md-block">
            <Button
              className="hero-button"
              variant="primary"
              href={contentBlock?.button?.link}
            >
              {contentBlock?.button?.text}
            </Button>
          </div>
        )}
      </div>
      {contentBlock?.image && !hideImage && (
        <div className="feature-image">
          <Image
            src={urlForImage(contentBlock?.image)?.url() as string}
            alt="Features Image"
            width={
              contentBlock?.image?.imgAsset?.metadata?.dimensions?.width || 300
            }
            height={
              contentBlock?.image?.imgAsset?.metadata?.dimensions?.height || 500
            }
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            placeholder="blur"
            blurDataURL={
              contentBlock?.image?.imgAsset?.metadata?.lqip ||
              imageData.blurImage
            }
          />
        </div>
      )}
      {contentBlock?.button?.text && (
        <div className="button-outer d-block d-md-none">
          <Button
            className="hero-button"
            variant="primary"
            href={contentBlock?.button?.link}
          >
            {contentBlock?.button?.text}
          </Button>
        </div>
      )}
    </div>
  );
}
